module.exports = __webpack_public_path__ + "img/bg-4.dc930aec.png";